export default "__VITE_ASSET__BBGl0T8I__"